(function(){'use strict';
function load(section){
  if(!section||section.dataset.bpbRelatedBound==='true'||section.dataset.ready==='true')return;
  section.dataset.bpbRelatedBound='true';
  var url=section.getAttribute('data-url');
  if(!url)return;
  var run=function(){
    fetch(url,{credentials:'same-origin'}).then(function(r){if(!r.ok)throw new Error('Recommendations unavailable');return r.text()})
      .then(function(text){
        var doc=new DOMParser().parseFromString(text,'text/html');
        var incoming=doc.querySelector('[data-bpb-related]');
        var grid=incoming&&incoming.querySelector('[data-bpb-related-grid]');
        if(!grid||!grid.children.length){section.hidden=true;return}
        section.innerHTML=incoming.innerHTML;
        section.dataset.ready='true';
        section.hidden=false;
      }).catch(function(){section.hidden=true});
  };
  if('IntersectionObserver'in window){
    var sentinel=section.querySelector('.bpb-discovery-sentinel')||section;
    var observer=new IntersectionObserver(function(entries){if(!entries[0].isIntersecting)return;observer.disconnect();run()},{rootMargin:'0px 0px 300px 0px'});
    observer.observe(sentinel);
  }else{run()}
}
function init(){document.querySelectorAll('[data-bpb-related]').forEach(load)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();